// extracted by mini-css-extract-plugin
export default {"item":"item_2g6N0","inactive":"inactive_3jvWx"};